import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import { getItemsCountingReport } from '../itemsCountingReportActions';
import ItemsCountingReportFilter from './ItemsCountingReportFilter';

const ItemsCountingReportFilterContainer = ({
  getItemsList,
  itemsList,
  getPublicZoneList,
  publicZoneList,
  getOfficesShortList,
  officesShortList,
  getOrganizationMembersList,
  orgMembersList,
  getItemsCountingReport,
  setSelectedParams,
  selectedParams,
}) => {
  return (
    <ItemsCountingReportFilter
      getItemsList={getItemsList}
      itemsList={itemsList}
      getPublicZoneList={getPublicZoneList}
      publicZoneList={publicZoneList}
      getOfficesShortList={getOfficesShortList}
      officesShortList={officesShortList}
      getOrganizationMembersList={getOrganizationMembersList}
      orgMembersList={orgMembersList}
      getItemsCountingReport={getItemsCountingReport}
      setSelectedParams={setSelectedParams}
      selectedParams={selectedParams}
    />
  );
};

const mapStateToProps = state => ({
  itemsList: state.items.itemsList,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  orgMembersList: state.project.orgMembersList,
});

const mapDispatchToProps = dispatch => ({
  getItemsList: params => dispatch(getItemsList(params)),
  getItemsCountingReport: params => dispatch(getItemsCountingReport(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemsCountingReportFilterContainer);
